import request from '../../axios';

export const getTakenLoanPaymentDetail = async (loanRequestGuid?: string) => {
  const {data}: {data: ITakenLoanPaymentDetailResponse} = await request.get(
    `/api/v2/payment/taken-loan/` + loanRequestGuid,
  );

  return data;
};
